/* tslint:disable */
/* eslint-disable */
/**
 * Salv AML Platform internal API
 * Salv AML Platform internal API
 *
 * The version of the OpenAPI document: 1.0.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
import type { InternalApiFinalRiskLevel } from './InternalApiFinalRiskLevel';
import {
    InternalApiFinalRiskLevelFromJSON,
    InternalApiFinalRiskLevelFromJSONTyped,
    InternalApiFinalRiskLevelToJSON,
    InternalApiFinalRiskLevelToJSONTyped,
} from './InternalApiFinalRiskLevel';

/**
 * 
 * @export
 * @interface InternalApiFinalRiskRangeEntry
 */
export interface InternalApiFinalRiskRangeEntry {
    /**
     * 
     * @type {InternalApiFinalRiskLevel}
     * @memberof InternalApiFinalRiskRangeEntry
     */
    level: InternalApiFinalRiskLevel;
    /**
     * 
     * @type {number}
     * @memberof InternalApiFinalRiskRangeEntry
     */
    scoreFrom: number;
    /**
     * 
     * @type {number}
     * @memberof InternalApiFinalRiskRangeEntry
     */
    scoreTo: number;
}



/**
 * Check if a given object implements the InternalApiFinalRiskRangeEntry interface.
 */
export function instanceOfInternalApiFinalRiskRangeEntry(value: object): value is InternalApiFinalRiskRangeEntry {
    if (!('level' in value) || value['level'] === undefined) return false;
    if (!('scoreFrom' in value) || value['scoreFrom'] === undefined) return false;
    if (!('scoreTo' in value) || value['scoreTo'] === undefined) return false;
    return true;
}

export function InternalApiFinalRiskRangeEntryFromJSON(json: any): InternalApiFinalRiskRangeEntry {
    return InternalApiFinalRiskRangeEntryFromJSONTyped(json, false);
}

export function InternalApiFinalRiskRangeEntryFromJSONTyped(json: any, ignoreDiscriminator: boolean): InternalApiFinalRiskRangeEntry {
    if (json == null) {
        return json;
    }
    return {
        
        'level': InternalApiFinalRiskLevelFromJSON(json['level']),
        'scoreFrom': json['scoreFrom'],
        'scoreTo': json['scoreTo'],
    };
}

export function InternalApiFinalRiskRangeEntryToJSON(json: any): InternalApiFinalRiskRangeEntry {
    return InternalApiFinalRiskRangeEntryToJSONTyped(json, false);
}

export function InternalApiFinalRiskRangeEntryToJSONTyped(value?: InternalApiFinalRiskRangeEntry | null, ignoreDiscriminator: boolean = false): any {
    if (value == null) {
        return value;
    }

    return {
        
        'level': InternalApiFinalRiskLevelToJSON(value['level']),
        'scoreFrom': value['scoreFrom'],
        'scoreTo': value['scoreTo'],
    };
}

